import { Injectable } from '@angular/core';
import {
  CreateProviderContactChangeRequest,
  ProviderContactChange,
  ProviderContactChangeChannel,
  SubmitRestoreContactsRequest,
} from '@models';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';
import { ProviderContactChangeService } from './provider-contact-change.service';

@Injectable({ providedIn: 'root' })
export class ProviderContactChangeApiService
  extends HttpService<ProviderContactChange>
  implements ProviderContactChangeService
{
  protected override readonly collectionPath = '/providers/patients';

  create(
    patientId: string,
    request: CreateProviderContactChangeRequest
  ): Observable<ProviderContactChange> {
    return this.http.post<ProviderContactChange>(
      this.changesUrl(patientId),
      request
    );
  }

  get(patientId: string, id: string): Observable<ProviderContactChange> {
    return this.http.get<ProviderContactChange>(
      `${this.changesUrl(patientId)}/${encodeURIComponent(id)}`
    );
  }

  approve(
    patientId: string,
    id: string,
    code: string
  ): Observable<ProviderContactChange> {
    return this.http.post<ProviderContactChange>(
      `${this.changesUrl(patientId)}/${encodeURIComponent(id)}/approve`,
      { code }
    );
  }

  submitContacts(
    patientId: string,
    id: string,
    request: SubmitRestoreContactsRequest
  ): Observable<ProviderContactChange> {
    return this.http.put<ProviderContactChange>(
      `${this.changesUrl(patientId)}/${encodeURIComponent(id)}/contacts`,
      request
    );
  }

  verify(
    patientId: string,
    id: string,
    code: string,
    channel?: ProviderContactChangeChannel
  ): Observable<ProviderContactChange> {
    return this.http.post<ProviderContactChange>(
      `${this.changesUrl(patientId)}/${encodeURIComponent(id)}/verify`,
      channel ? { code, channel } : { code }
    );
  }

  resend(
    patientId: string,
    id: string,
    channel?: ProviderContactChangeChannel
  ): Observable<ProviderContactChange> {
    return this.http.post<ProviderContactChange>(
      `${this.changesUrl(patientId)}/${encodeURIComponent(id)}/resend`,
      channel ? { channel } : {}
    );
  }

  cancel(patientId: string, id: string): Observable<ProviderContactChange> {
    return this.http.delete<ProviderContactChange>(
      `${this.changesUrl(patientId)}/${encodeURIComponent(id)}`
    );
  }

  private changesUrl(patientId: string): string {
    return `${this.apiUrl}/${encodeURIComponent(patientId)}/contact-changes`;
  }
}
